var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{class:{
		'mt-0': _vm.dense,
		'pt-0': _vm.dense,
	},attrs:{"label":_vm.label,"dense":_vm.dense,"disabled":_vm.disabled,"value":_vm.value},on:{"change":function($event){return _vm.onChange($event)}},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})}
var staticRenderFns = []

export { render, staticRenderFns }